var oe = Object.defineProperty, ce = Object.defineProperties;
var se = Object.getOwnPropertyDescriptors;
var V = Object.getOwnPropertySymbols;
var ue = Object.prototype.hasOwnProperty, le = Object.prototype.propertyIsEnumerable;
var B = (e, t, n) => t in e ? oe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, i = (e, t) => {
  for (var n in t || (t = {}))
    ue.call(t, n) && B(e, n, t[n]);
  if (V)
    for (var n of V(t))
      le.call(t, n) && B(e, n, t[n]);
  return e;
}, p = (e, t) => ce(e, se(t));
var ie = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
var $ = (e, t, n) => new Promise((r, a) => {
  var o = (u) => {
    try {
      s(n.next(u));
    } catch (d) {
      a(d);
    }
  }, c = (u) => {
    try {
      s(n.throw(u));
    } catch (d) {
      a(d);
    }
  }, s = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(o, c);
  s((n = n.apply(e, t)).next());
});
var Ht = ie((ne) => {
  const l = "data-mesh-", de = `${l}root`, ge = `${l}source-frontend-module`, Ae = `${l}source-frontend-module-version`, pe = `${l}rendered`, ye = `${l}removed`, he = `${l}clicked`, me = `${l}value-changed`, fe = `${l}values-changed`, Te = `${l}page-started`, h = `${l}rows`, T = `${l}row`, ve = `${l}row-clicked`, Ee = `${l}rows-changed`, m = `${l}cell`, Ce = `${l}cell-clicked`, be = `${l}cell-value-changed`, f = `${l}business-concept`, Se = `${l}intention`, De = `${l}feedback`, Le = `${l}ui-element`, H = `${l}backend-aggregate`, Re = `${l}form`, D = `${l}input-group`, E = `${l}input`, W = `${l}locally-submitted`, U = `${l}locally-submitted-trigger`, x = "domain-events", _e = "/frontend-domain-events-publisher/v1/frontend-domain-events", S = (e, t, n) => n[e] ? { [t]: n[e] } : {}, G = (e) => i(i(i(i({
    protocol: e.protocol.replace(":", ""),
    host: e.hostname
  }, S("port", "port", e)), S("pathname", "path", e)), S("search", "query", e)), S("hash", "anchor", e)), Pe = () => G(window.location), we = () => {
    if (!document.referrer) return null;
    const e = new URL(document.referrer);
    return G(e);
  }, q = (e, t) => {
    let n = e, r = null, a = null;
    for (; n !== null && n !== t; ) {
      if (r = n.getAttribute(ge), a = n.getAttribute(Ae), r && a)
        return {
          sourceFrontendModule: r,
          sourceFrontendModuleVersion: a
        };
      n = n.parentElement;
    }
  }, K = () => Date.now(), j = (e) => ({
    create({
      module: t,
      count: n
    }) {
      e.previousValue.clear();
      const { count: r } = e.pageStarted.get(), a = we(), c = {
        eventName: "PageStarted",
        eventBody: i(i(p(i({}, t), {
          deviceTimestamp: K(),
          count: n,
          url: Pe()
        }), a && { referrer: a }), r > 0 ? { referrerPageStartedData: r } : {})
      };
      return e.pageStarted.set({ count: n, module: t }), c;
    }
  }), Ne = (e, t) => {
    const n = j(e);
    return {
      create({
        target: r,
        count: a
      }) {
        const c = q(r, t);
        return n.create({ module: c, count: a });
      }
    };
  }, ke = (e) => {
    const t = j(e);
    return {
      create(n) {
        return t.create(n);
      }
    };
  }, J = (e) => {
    try {
      const { name: t, value: n } = JSON.parse(e || "{}");
      return typeof t != "string" ? {} : {
        [t]: n || null
      };
    } catch (t) {
      return console.error("Error parsing backend aggregate", t), {};
    }
  }, Ve = (e, t) => {
    const { count: n } = t.pageStarted.get(), r = (e == null ? void 0 : e.getAttribute(H)) || null;
    return i(i({}, n && { pageStarted: n }), J(r));
  }, Be = ({
    element: e,
    eventType: t,
    businessConceptPrefix: n
  }) => {
    const r = {
      feedback: "/",
      intention: ":",
      uiElement: "-"
    }, a = (e == null ? void 0 : e.getAttribute(f)) || "", o = (e == null ? void 0 : e.getAttribute(De)) || "", c = (e == null ? void 0 : e.getAttribute(Se)) || "", s = (e == null ? void 0 : e.getAttribute(Le)) || "", u = [];
    if (a) {
      const g = n ? `${n}${a}` : a;
      u.push(g);
    } else
      return t;
    c && u.push(r.intention + c), o && u.push(r.feedback + o), s && u.push(r.uiElement + s);
    const d = u.join("");
    return d ? `${d}_${t}` : t;
  }, y = ({
    eventType: e,
    store: t,
    root: n
  }) => ({
    create({
      elementWithDataNameAttrs: r,
      elementWithDataBackendAggregate: a,
      businessConceptPrefix: o,
      count: c
    }) {
      const s = Be({
        element: r,
        eventType: e,
        businessConceptPrefix: o
      }), u = t.pageStarted.get(), d = u.module ? u.module : a ? q(a, n) : null;
      return {
        eventName: s,
        eventBody: i(i({
          deviceTimestamp: K(),
          count: c
        }, Ve(a, t)), d)
      };
    }
  }), $e = (e, t) => {
    const n = y({
      eventType: "Removed",
      store: e,
      root: t
    });
    return {
      create({ target: r, count: a }) {
        return n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: r,
          count: a
        });
      }
    };
  }, Fe = (e, t) => {
    const n = y({
      eventType: "Rendered",
      store: e,
      root: t
    });
    return {
      create({ target: r, count: a }) {
        return n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: r,
          count: a
        });
      }
    };
  }, Ie = (e) => e.closest(`[${h}]`), L = (e) => Array.from(e.querySelectorAll(`[${T}]`)).filter(
    (t) => Ie(t) === e
  ), Oe = (e, t) => {
    const n = y({
      eventType: "RowsChanged",
      store: e,
      root: t
    });
    return {
      create({ target: r, count: a }) {
        const o = r, { eventName: c, eventBody: s } = n.create({
          elementWithDataNameAttrs: o,
          elementWithDataBackendAggregate: o,
          count: a
        }), u = /* @__PURE__ */ new Set();
        return L(o).forEach((A) => {
          const v = A.getAttribute(H);
          u.add(J(v));
        }), {
          eventName: c,
          eventBody: p(i({}, s), {
            rows: Array.from(u)
          })
        };
      }
    };
  }, R = (e, t) => e.nodeType === Node.ELEMENT_NODE && e.hasAttribute(t), Me = () => new Promise((e) => {
    setTimeout(e, 0);
  }), He = (e, t) => ({
    done: !1,
    value: {
      element: e,
      attrs: t
    }
  }), Y = ({
    element: e,
    root: t,
    attrs: n
  }) => {
    let r = e, a = !1;
    const o = (c) => n.filter((s) => c.hasAttribute(s));
    return {
      next() {
        for (; r && !a; ) {
          const c = o(r);
          if (c.length > 0) {
            const s = He(r, c);
            return r = r.parentElement, s;
          }
          a = r === t, r = r.parentElement;
        }
        return {
          done: !0
        };
      }
    };
  }, We = {
    attributes: !1,
    childList: !0,
    subtree: !0
  }, Ue = [m, T, h], X = (e) => (t, n) => {
    if (!t)
      return null;
    const a = Y({
      element: t,
      root: n,
      attrs: e
    }).next();
    return a.done ? null : a.value.element;
  }, xe = X([h]), Ge = X(Ue), F = (e, t) => e.hasAttribute(Ee) ? !Ge(e.parentElement, t) : !1, qe = (e, t) => {
    const n = /* @__PURE__ */ new Map();
    return {
      createCollector(r) {
        return {
          add(a, o) {
            if (o.skipRowsChanged)
              return o;
            const c = i({}, o);
            if (a.hasAttribute(m))
              c.skipRowsChanged = !0;
            else if (a.hasAttribute(T)) {
              const s = xe(r.target, e);
              if (s && F(s, e) && !n.has(s)) {
                const { count: u } = t.counter.increment();
                n.set(s, u), t.lists.add(s, { count: u });
              }
              c.skipRowsChanged = !0;
            } else if (a.hasAttribute(h)) {
              if (o.type === "removed")
                t.lists.delete(a);
              else if (F(a, e) && !n.has(a)) {
                const { count: s } = t.counter.increment();
                n.set(a, s), t.lists.add(a, { count: s });
              }
              c.skipRowsChanged = !0;
            }
            return c;
          }
        };
      },
      build() {
        return [...n].map(
          ([r, a]) => ({
            eventType: "RowsChanged",
            target: r,
            count: a
          })
        );
      }
    };
  }, Ke = (e, t) => {
    const n = [], r = (o, c) => {
      let s = c;
      o instanceof Element && (!c.skipPageStarted && R(o, Te) && (n.push({
        eventType: "PageStarted",
        target: o,
        count: t.counter.increment().count
      }), s = p(i({}, c), { skipPageStarted: !0 })), R(o, pe) && n.push({
        eventType: "Rendered",
        target: o,
        count: t.counter.increment().count
      }), s = e.add(o, s), o.childNodes.forEach((u) => r(u, s)));
    }, a = (o, c) => {
      if (!(o instanceof Element))
        return;
      R(o, ye) && n.push({
        eventType: "Removed",
        target: o,
        count: t.counter.increment().count
      });
      const s = e.add(o, c);
      o.childNodes.forEach((u) => a(u, s));
    };
    return {
      collectAdded(o) {
        r(o, {
          skipRowsChanged: !1,
          skipPageStarted: !1,
          type: "added"
        });
      },
      collectRemoved(o) {
        a(o, {
          skipRowsChanged: !1,
          skipPageStarted: !1,
          type: "removed"
        });
      },
      build() {
        return n;
      }
    };
  }, je = (e, t) => {
    const n = [], r = qe(e, t);
    return {
      add(a) {
        if (a.type !== "childList") return;
        const o = r.createCollector(a), c = Ke(
          o,
          t
        );
        a.addedNodes.forEach(c.collectAdded), a.removedNodes.forEach(c.collectRemoved), n.push(...c.build());
      },
      build() {
        return n.push(...r.build()), n;
      }
    };
  }, Je = (e, t, n) => ({
    handle: (r) => $(ne, null, function* () {
      const a = je(e, t);
      for (const c of r)
        a.add(c), yield Me();
      const o = a.build();
      o.length && n(o);
    })
  }), Ye = (e, t, n) => {
    const r = Je(e, t, n), a = new MutationObserver(r.handle);
    return a.observe(e, We), {
      stop: () => a.disconnect()
    };
  }, P = (e) => {
    const t = Array.isArray(e) ? e : [e], n = new Blob([JSON.stringify(t)], {
      type: "application/json; charset=UTF-8"
    });
    navigator.sendBeacon(_e, n);
  }, z = (e, t) => ({
    handle: ({
      eventType: r,
      target: a,
      count: o
    }) => {
      const s = e[r].create({ target: a, count: o });
      t(s);
    }
  }), w = (e) => z(e, P), Xe = (e) => {
    let t = [];
    const n = z(e, (a) => {
      t.push(a);
    });
    return {
      handle: (a) => {
        t = [], a.forEach(n.handle), t.length && P(t);
      }
    };
  }, ze = ({
    store: e,
    root: t
  }) => {
    const n = Xe({
      PageStarted: Ne(e, t),
      Rendered: Fe(e, t),
      Removed: $e(e, t),
      RowsChanged: Oe(e, t)
    });
    return Ye(t, e, n.handle);
  }, Qe = (e) => {
    const t = e.getAttribute("for"), n = e.querySelector("input");
    if (t) {
      const r = document.getElementById(t);
      if (r instanceof HTMLInputElement)
        return r;
    }
    return n instanceof HTMLInputElement ? n : null;
  }, Q = (e) => !e || !e.hasAttribute(Re) ? [] : e.querySelectorAll(
    `[${f}][${D}], [${f}][${E}]`
  ), Ze = () => {
    let e = {};
    return {
      add(t) {
        if (t.hasAttribute(m))
          e = {
            cell: {
              type: "default",
              element: t
            }
          };
        else if (t.tagName === "LABEL") {
          const n = Qe(t);
          n && n.hasAttribute(m) && (e = {
            cell: {
              type: "fromLabel",
              element: n
            }
          });
        } else t.hasAttribute(T) ? e = {
          cell: e.cell,
          row: t
        } : t.hasAttribute(h) && (e = e.row ? p(i({}, e), {
          rows: t
        }) : {});
      },
      build() {
        return e;
      }
    };
  }, et = (e, t, n) => ({
    handle: (r) => {
      const a = Ze();
      let o = r.target;
      for (; o && o !== e; ) {
        if (a.add(o), o.hasAttribute(he) && n({
          eventType: "Clicked",
          target: o,
          count: t.counter.increment().count
        }), o.hasAttribute(U)) {
          const g = ["INPUT", "TEXTAREA", "SELECT"].includes(o.tagName) ? null : o.closest(`[${W}]`), A = Q(g);
          g && A.length > 0 && n({
            eventType: "LocallySubmitted",
            target: {
              element: g,
              children: Array.from(A)
            },
            count: t.counter.increment().count
          });
        }
        o = o.parentElement;
      }
      const { cell: c, row: s, rows: u } = a.build();
      c && s && u && c.type === "default" && c.element.hasAttribute(Ce) && n({
        eventType: "CellClicked",
        target: {
          list: u,
          row: s,
          cell: c.element
        },
        count: t.counter.increment().count
      }), s && u && s.hasAttribute(ve) && !c && n({
        eventType: "RowClicked",
        target: {
          list: u,
          row: s
        },
        count: t.counter.increment().count
      });
    }
  }), tt = (e, t, n) => {
    const r = et(e, t, n);
    return e.addEventListener("click", r.handle), {
      stop: () => e.removeEventListener("click", r.handle)
    };
  }, nt = (e, t) => {
    const n = y({
      eventType: "CellClicked",
      store: e,
      root: t
    });
    return {
      create({
        target: { list: r, row: a, cell: o },
        count: c
      }) {
        var b;
        const s = r.getAttribute(f) || "", { eventName: u, eventBody: d } = n.create({
          businessConceptPrefix: s,
          elementWithDataNameAttrs: o,
          elementWithDataBackendAggregate: o,
          count: c
        }), g = L(r), A = Array.from(g).indexOf(a), v = ((b = e.lists.get(r)) == null ? void 0 : b.count) || null;
        return {
          eventName: u,
          eventBody: p(i({}, d), {
            rowPosition: A,
            rowsChanged: v
          })
        };
      }
    };
  }, rt = (e, t) => {
    const n = y({
      eventType: "RowClicked",
      store: e,
      root: t
    });
    return {
      create({
        target: { list: r, row: a },
        count: o
      }) {
        var A;
        const { eventName: c, eventBody: s } = n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: a,
          count: o
        }), u = L(r), d = Array.from(u).indexOf(a), g = ((A = e.lists.get(r)) == null ? void 0 : A.count) || null;
        return {
          eventName: c,
          eventBody: p(i({}, s), {
            rowPosition: d,
            rowsChanged: g
          })
        };
      }
    };
  }, at = (e, t) => {
    const n = y({
      eventType: "Clicked",
      store: e,
      root: t
    });
    return {
      create({ target: r, count: a }) {
        return n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: r,
          count: a
        });
      }
    };
  }, ot = (e, t) => {
    const { simpleSuffix: n = "InputValue", multipleSuffix: r = "InputValues" } = {};
    return Object.entries(e).reduce((a, [o, c]) => {
      const s = Array.isArray(c), u = `${o}${s ? r : n}`;
      return a[u] = c, a;
    }, {});
  }, C = (e) => e instanceof HTMLInputElement ? e.type === "checkbox" ? e.value && e.value !== "on" ? e.checked ? e.value : !1 : e.checked : e.type === "radio" ? e.value && e.value !== "on" ? e.value : null : e.value : e instanceof HTMLSelectElement ? e.multiple ? Array.from(e.selectedOptions).map((t) => t.value) : e.value : e instanceof HTMLTextAreaElement ? e.value : null, Z = ({
    element: e,
    children: t
  }) => e instanceof HTMLSelectElement ? C(e) : Array.from(t).reduce((n, r) => {
    const a = C(r);
    return r instanceof HTMLInputElement && r.type === "checkbox" ? r.checked && n.push(a) : n.push(a), n;
  }, []), ct = (e) => Array.from(e).reduce((t, n) => {
    const r = n.getAttribute(f);
    if (r) {
      if (n.hasAttribute(E))
        t[r] = C(n);
      else if (n.hasAttribute(D)) {
        const a = Array.from(n.querySelectorAll(`[${E}]`));
        t[r] = Z({
          element: n,
          children: a
        });
      }
    }
    return t;
  }, {}), ee = (e, t) => {
    const n = y({
      eventType: "LocallySubmitted",
      store: e,
      root: t
    });
    return {
      create({
        target: { element: r, children: a },
        count: o
      }) {
        const c = ct(a), { eventName: s, eventBody: u } = n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: r,
          count: o
        });
        return {
          eventName: s,
          eventBody: i(i({}, u), ot(c))
        };
      }
    };
  }, st = ({
    store: e,
    root: t
  }) => {
    const n = w({
      CellClicked: nt(e, t),
      RowClicked: rt(e, t),
      Clicked: at(e, t),
      LocallySubmitted: ee(e, t)
    });
    return tt(t, e, n.handle);
  }, ut = [m, T, h], N = (e, t) => (n) => n.attrs.length === 1 && n.attrs[0] === t ? { alias: e, element: n.element } : null, lt = N("cell", m), it = N("row", T), dt = N("list", h), gt = (e) => (t) => t.element === e ? lt(t) : null, At = (e, t) => {
    const n = [gt(e), it, dt], r = Y({
      element: e,
      root: t,
      attrs: ut
    }), a = {
      list: t,
      row: t,
      cell: t
    };
    for (const c of n) {
      const s = r.next();
      if (s.done)
        return null;
      const u = c(s.value);
      if (!u)
        return null;
      a[u.alias] = u.element;
    }
    return r.next().done ? a : null;
  }, pt = (e, t, n, r) => ({
    handle: r((a) => {
      const o = a.target;
      if (o.hasAttribute(me) && n({
        eventType: "ValueChanged",
        target: o,
        count: t.counter.increment().count
      }), o.hasAttribute(be)) {
        const c = At(o, e);
        c && n({
          eventType: "CellValueChanged",
          target: c,
          count: t.counter.increment().count
        });
      }
    }, 500)
  }), yt = (e, t, n, r) => {
    const a = pt(e, t, n, r);
    return e.addEventListener("input", a.handle), {
      stop: () => e.removeEventListener("input", a.handle)
    };
  }, ht = (e, t) => {
    const n = y({
      eventType: "CellValueChanged",
      store: e,
      root: t
    });
    return {
      create({
        target: { list: r, row: a, cell: o },
        count: c
      }) {
        var k;
        const s = r.getAttribute(f) || "", { eventName: u, eventBody: d } = n.create({
          businessConceptPrefix: s,
          elementWithDataNameAttrs: o,
          elementWithDataBackendAggregate: o,
          count: c
        }), g = C(o), A = e.previousValue.get(u), v = L(r), b = Array.from(v).indexOf(a), re = ((k = e.lists.get(r)) == null ? void 0 : k.count) || null, ae = {
          eventName: u,
          eventBody: p(i({}, d), {
            value: g,
            previousValue: A,
            rowPosition: b,
            rowsChanged: re
          })
        };
        return e.previousValue.set(u, g), ae;
      }
    };
  }, mt = (e, t) => {
    const n = y({
      eventType: "ValueChanged",
      store: e,
      root: t
    });
    return {
      create({ target: r, count: a }) {
        const { eventName: o, eventBody: c } = n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: r,
          count: a
        }), s = C(r), u = e.previousValue.get(o), d = {
          eventName: o,
          eventBody: p(i({}, c), {
            value: s,
            previousValue: u
          })
        };
        return e.previousValue.set(o, s), d;
      }
    };
  }, ft = (e, t) => {
    let n;
    return function(...r) {
      clearTimeout(n), n = setTimeout(() => e(...r), t);
    };
  }, Tt = ({
    store: e,
    root: t
  }) => {
    const n = w({
      ValueChanged: mt(e, t),
      CellValueChanged: ht(e, t)
    });
    return yt(t, e, n.handle, ft);
  }, te = (e, t) => {
    const n = y({
      eventType: "ValuesChanged",
      store: e,
      root: t
    });
    return {
      create({
        target: r,
        values: a,
        count: o
      }) {
        const { eventName: c, eventBody: s } = n.create({
          elementWithDataNameAttrs: r,
          elementWithDataBackendAggregate: r,
          count: o
        }), u = e.previousValue.get(c), d = {
          eventName: c,
          eventBody: p(i({}, s), {
            count: o,
            values: a,
            previousValue: u
          })
        };
        return e.previousValue.set(c, a), d;
      }
    };
  }, vt = (e, t) => {
    const n = te(
      e,
      t
    );
    return {
      create({ target: r, count: a }) {
        const o = Z(r);
        return n.create({
          target: r.element,
          values: o,
          count: a
        });
      }
    };
  }, I = (e) => e.hasAttribute(D) && e.hasAttribute(fe), Et = (e) => e instanceof HTMLSelectElement && e.multiple, Ct = (e, t) => ({
    handle: (n) => {
      const r = n.target;
      if (r.hasAttribute(U)) {
        const a = r.closest(`[${W}]`), o = Q(a);
        a && o.length > 0 && e({
          eventType: "LocallySubmitted",
          target: {
            element: a,
            children: Array.from(o)
          },
          count: t.counter.increment().count
        });
      }
      if (r.hasAttribute(E)) {
        const a = r.closest(`[${D}]`), o = a ? Array.from(a.querySelectorAll(`[${E}]`)) : [];
        a && I(a) && o.length > 0 && e({
          eventType: "ValuesChanged",
          target: {
            element: a,
            children: Array.from(o)
          },
          count: t.counter.increment().count
        });
      }
      Et(r) && I(r) && e({
        eventType: "SelectValuesChanged",
        target: r,
        count: t.counter.increment().count
      });
    }
  }), bt = (e, t, n) => {
    const r = Ct(n, t);
    return e.addEventListener("change", r.handle), {
      stop: () => e.removeEventListener("change", r.handle)
    };
  }, St = (e) => Array.from(e.selectedOptions).map((t) => t.value), Dt = (e, t) => {
    const n = te(
      e,
      t
    );
    return {
      create({ target: r, count: a }) {
        const o = St(r);
        return n.create({ target: r, values: o, count: a });
      }
    };
  }, Lt = ({
    store: e,
    root: t
  }) => {
    const n = w({
      SelectValuesChanged: Dt(e, t),
      LocallySubmitted: ee(e, t),
      ValuesChanged: vt(e, t)
    });
    return bt(t, e, n.handle);
  }, Rt = "DataMesh", O = `${Rt}:PageStarted`, _t = (e) => {
    const t = ke(e), n = (r) => {
      const { detail: a } = r, { count: o } = e.counter.increment(), c = t.create({
        module: a || void 0,
        count: o
      });
      P(c);
    };
    return document.body.addEventListener(O, n), {
      stop() {
        document.body.removeEventListener(O, n);
      }
    };
  }, Pt = ({
    root: e,
    store: t
  }) => {
    const n = _t(t).stop;
    let r, a, o, c;
    return e && (r = ze({ store: t, root: e }).stop, a = st({ store: t, root: e }).stop, o = Tt({ store: t, root: e }).stop, c = Lt({ store: t, root: e }).stop), {
      stop: () => {
        n(), e && (r(), a(), o(), c());
      }
    };
  }, wt = (e) => !!e && typeof e == "object", Nt = (e) => wt(e) && typeof e.count == "number" && e.count >= 0 && Number.isInteger(e.count), _ = () => {
    const e = localStorage.getItem(x);
    if (!e)
      return null;
    let t;
    try {
      t = JSON.parse(e);
    } catch (n) {
      return console.error("Error parsing localStorage data:", n), null;
    }
    return Nt(t) ? t : null;
  }, M = (e) => {
    try {
      const t = _() || {}, n = i(i({}, t), e), r = JSON.stringify(n);
      localStorage.setItem(x, r);
    } catch (t) {
      console.error("Error setting localStorage data:", t);
    }
  }, kt = (e) => !!e && typeof e == "object" && typeof (e == null ? void 0 : e.count) == "number", Vt = () => {
    let e = 0;
    return M({ count: e }), {
      get() {
        const { count: t } = _() || {};
        return { count: t != null ? t : 0 };
      },
      increment() {
        var n;
        const t = _();
        return e = (n = t == null ? void 0 : t.count) != null ? n : 0, kt(t) || (e = 0), e += 1, M({ count: e }), {
          count: e
        };
      }
    };
  }, Bt = () => {
    const e = /* @__PURE__ */ new Map();
    return {
      add(t, n) {
        e.set(t, n);
      },
      get(t) {
        return e.get(t);
      },
      delete(t) {
        e.delete(t);
      }
    };
  }, $t = () => {
    let e = {
      count: 0
    };
    return {
      get() {
        return e;
      },
      set(t) {
        e = t;
      },
      clear() {
        e = {
          count: 0
        };
      }
    };
  }, Ft = () => {
    let e = {};
    return {
      set(t, n) {
        e[t] = n;
      },
      get(t) {
        return e[t] || null;
      },
      clear() {
        e = {};
      }
    };
  }, It = () => ({
    counter: Vt(),
    lists: Bt(),
    pageStarted: $t(),
    previousValue: Ft()
  }), Ot = document.querySelector(`[${de}]`), Mt = It();
  Pt({ root: Ot, store: Mt });
});
export default Ht();
